import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {ArticleDialogData, ArticleProps} from "./types/article-modal.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {titleModal} from "./configs/article-modal-config";
import {MatAnchor, MatButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'app-article-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatAnchor,
    MatTooltip
  ],
  templateUrl: './article-modal.component.html',
  styleUrl: './article-modal.component.scss'
})
export class ArticleModalComponent extends BaseModalComponent {
  public articleDialogData = inject<ArticleDialogData>(MAT_DIALOG_DATA);

  public readonly titleModal = titleModal;

  public articles: Array<ArticleProps> = [];

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(this.articleDialogData.modalKey);
    this.articles = this.articleDialogData.nmIds?.wildberriesArticles || this.articleDialogData.skus?.ozonArticles || [];
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(this.articleDialogData.modalKey);
  }

}
